.breadcrumbs-container {
    /* Allow shrinking the breadcrumbs before the buttons. Without this, the
    buttons slide off the screen and the breadcrumbs don't shrink at all */
    flex-shrink: 1 !important;
    /* The buttons have a margin on them already, so don't double it to give us
    some more breathing room */
    margin-right: 0 !important;
}
